
import React, { useEffect, useState } from "react";
import {
  collection,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";

import { db } from "../firebase";
import VolatilityHeader from "./VolatilityHeader";
import BottomNavVolatility from "./BottomNavVolatility";
import "./VolatilityOpen.css";

const getDate = (value) => {
  if (!value) return "—";

  if (typeof value.toDate === "function") {
    return value.toDate().toLocaleString();
  }

  if (typeof value.seconds === "number") {
    return new Date(value.seconds * 1000).toLocaleString();
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? "—"
    : date.toLocaleString();
};

const Open = () => {
  const [trades, setTrades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const username = (
      localStorage.getItem("username") || ""
    ).trim();

    if (!username) {
      setTrades([]);
      setLoading(false);
      setError("Username haijapatikana. Ingia tena.");
      return undefined;
    }

    const q = query(
      collection(db, "volatilityorder"),
      where("username", "==", username)
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const rows = snapshot.docs
          .map((item) => ({
            id: item.id,
            ...item.data(),
          }))
          .filter(
            (trade) =>
              String(trade.status || "").toUpperCase() === "OPEN"
          )
          .sort((a, b) => {
            const dateA =
              a.createdAt?.toMillis?.() ||
              a.createdAt?.seconds * 1000 ||
              0;
            const dateB =
              b.createdAt?.toMillis?.() ||
              b.createdAt?.seconds * 1000 ||
              0;
            return dateB - dateA;
          });

        setTrades(rows);
        setLoading(false);
        setError("");
      },
      (err) => {
        console.error("Open trades error:", err);
        setError("Imeshindikana kupakia open trades.");
        setLoading(false);
      }
    );

    return unsubscribe;
  }, []);

  return (
    <div className="trade-records-page">
      <VolatilityHeader />

      <main className="trade-records-container">
        <div className="trade-records-heading">
          <div>
            <h1>Open Trades</h1>
            <p>Trades ambazo bado ziko wazi</p>
          </div>

          <span className="record-count">
            {trades.length} trades
          </span>
        </div>

        {loading ? (
          <div className="record-message">Inapakia records...</div>
        ) : error ? (
          <div className="record-message record-error">{error}</div>
        ) : trades.length === 0 ? (
          <div className="record-empty">
            <h2>Hakuna open trades</h2>
            <p>Trades zako zilizo wazi zitaonekana hapa.</p>
          </div>
        ) : (
          <div className="record-list">
            {trades.map((trade) => (
              <article className="record-card record-open" key={trade.id}>
                <div className="record-card-top">
                  <div>
                    <h2>
                      {trade.tradeType || trade.type ||
                        trade.contractType || "Trade"}
                    </h2>
                    <p>{trade.marketName || trade.marketSymbol || "Volatility"}</p>
                  </div>

                  <span className="record-status">OPEN</span>
                </div>

                <div className="record-grid">
                  <div>
                    <span>Trade ID</span>
                    <strong>{trade.localTradeId || trade.tradeId || trade.id}</strong>
                  </div>

                  <div>
                    <span>Stake</span>
                    <strong>
                      {Number(trade.stake ?? trade.amount ?? 0).toFixed(2)}
                    </strong>
                  </div>

                  <div>
                    <span>Entry Price</span>
                    <strong>{trade.entryPrice ?? "—"}</strong>
                  </div>

                  <div>
                    <span>Entry Digit</span>
                    <strong>{trade.entryDigit ?? "—"}</strong>
                  </div>

                  <div>
                    <span>Prediction</span>
                    <strong>{trade.prediction ?? trade.barrier ?? "—"}</strong>
                  </div>

                  <div>
                    <span>Date</span>
                    <strong>{getDate(trade.createdAt)}</strong>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </main>

      <BottomNavVolatility />
    </div>
  );
};

export default Open;